import React from "react";
import { WhatsappLogo } from "@phosphor-icons/react";
import { useT, useI18n } from "../lib/i18n";

export default function WhatsAppButton() {
  const { lang } = useI18n();
  const t = useT();
  const number = "919519078666";
  const msg = encodeURIComponent(
    lang === "hi"
      ? "नमस्ते युवा आयुर्वेदिक, मैं परामर्श बुक करना चाहता/चाहती हूँ।"
      : "Hello Yuva Ayurvedic Clinic Private Limited, I'd like to book a consultation."
  );
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-sage text-cream flex items-center justify-center shadow-lg hover:bg-terracotta hover:-translate-y-1 transition-all duration-300"
      aria-label={t("whatsapp.aria")}
    >
      <WhatsappLogo size={28} weight="fill" />
    </a>
  );
}
